@if (isVisible) {
  <div class="dialog re-min-w-mobile" animate.enter="bdo-fade" animate.leave="bdo-fade-leave">
    <div class="re-relative md:re-h-screen lg:re-h-auto">
      @if (icon) {
        <div class="re-mx-auto bdo-space--bottom re-w-75 re-h-75">
          @if (icon === 'success') {
            <svg-icon class="re-w-50 re-text-success re-stroke-current re-fill-current" src="assets/icons/system_icons/ok-circle.svg"></svg-icon>
          }
          @if (icon === 'error') {
            <svg-icon class="re-w-50 re-text-error re-stroke-current re-fill-current" src="assets/icons/system_icons/alert.svg"></svg-icon>
          }
          @if (icon === 'warning') {
            <svg-icon class="re-w-50 re-text-alert re-stroke-current re-fill-current" src="assets/icons/system_icons/alert.svg"></svg-icon>
          }
        </div>
      }
      @if (title) {
        <h4 class="bdo-space--top bdo-space--bottom center"> {{title}} </h4>
      }
      <ng-content></ng-content>
    </div>
    @if (isManuallyClosable) {
      <button (click)="onClose()" class="dialog__close-btn re-bg-no"
          [ngClass]="{
            're-w-25 re-h-25 re-text-white hover:re-text-primary-hover': closeButtonModifier && !isSolid,
            're-w-20 re-h-20 hover:re-text-secondary-hover': !closeButtonModifier && !isSolid,
            're-p-15 re-w-50 re-h-50 re-bg-white re-text-primary-hover hover:re-bg-primary hover:re-text-white': isSolid
          }"
        title="{{ 'general.action.close' | translate }}"
        type="button">
        <svg-icon src="assets/icons/close.svg"></svg-icon>
      </button>
    }
  </div>
}
@if (isVisible) {
  <div class="overlay" (click)="onClose()" animate.enter="bdo-fade" animate.leave="bdo-fade-leave"></div>
}
